import styled, { css, keyframes } from 'styled-components';
import get from 'lodash/get';

import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

import {
    SLOT_HEIGHT,
    ARROW_WIDTH,
    ROW_GUTTER_WIDTH,
    MOBILE_SLOT_WIDTH_XXSMALL,
    COLUMN_GUTTER_WIDTH,
} from '../constants';

const baseSlotStyles = css`
    align-items: center;
    border: none;
    box-sizing: border-box;
    display: flex;
    font: 13px/1 ${FontFamily.SharpSansSemibold};
    height: ${SLOT_HEIGHT}px;
    justify-content: center;
    padding: 0;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
`;

export const themedEmptySlotStyles = css`
    ${baseSlotStyles}

    background-color: ${getThemeConfig('slot.bgColorEmpty')};
    border: 1px solid ${getThemeConfig('slot.borderColorEmpty')};
    color: ${getThemeConfig('slot.textColorEmpty')};

    :hover {
        background-color: ${getThemeConfig('slot.bgColorEmpty')};
        color: ${getThemeConfig('slot.textColorEmpty')};
    }
`;

export const desktopSlotStyles = css`
    margin-top: ${ROW_GUTTER_WIDTH}px;

    :first-child {
        margin-top: 0;
    }
`;

const fade = keyframes`
    0% { opacity: 1; }
    100% { opacity: 0.3; }
`;

const fadeIn = keyframes`
    from { opacity: 0.01; }
    to { opacity: 1; }
`;

export const fadeAnimation = css`
    animation: ${fade} 750ms ease-in-out infinite alternate;
`;

export const fadeInAnimation = css`
    animation: 0.1s ${fadeIn} ease-out 1 forwards;
`;

export const themedSlotStyles = css`
    ${baseSlotStyles}
    ${fadeInAnimation}
    cursor: pointer;

    background-color: ${getThemeConfig('slot.bgColor')};
    border: 1px solid ${getThemeConfig('slot.borderColor')};
    color: ${getThemeConfig('slot.textColor')};

    &:hover {
        background-color: ${getThemeConfig('slot.bgColorHover')};
        border-color: ${getThemeConfig('slot.borderColorHover')};
        color: ${getThemeConfig('slot.textColorHover')};
    }

    &:active {
        background-color: ${getThemeConfig('slot.bgColorActive')};
        border-color: ${getThemeConfig('slot.borderColorActive')};
        color: ${getThemeConfig('slot.textColorActive')};
    }
`;

export const ThemedButton = styled.button`
    ${themedSlotStyles}
    border: 0;
    cursor: pointer;
    width: 100%;
`;

export const DesktopViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: ${p => p.minHeight || 0}px;
    overflow: visible;
    padding: 0px ${ARROW_WIDTH}px;
`;

export const MobileViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: ${p => p.minHeight || 0}px;
`;

export const DesktopTimeslot = styled.a`
    ${themedSlotStyles}
    ${desktopSlotStyles}
`;

export const MobileTimeslot = styled.a`
    ${themedSlotStyles}
    flex: 0 0 auto;
    width: ${MOBILE_SLOT_WIDTH_XXSMALL}px;

    :not(:first-child) {
        margin-left: ${COLUMN_GUTTER_WIDTH}px;
    }
`;

function getThemeConfig(selector) {
    return props =>
        get(props, `theme.components.AppointmentPicker.${selector}`);
}
